module.exports = __webpack_public_path__ + "img/HelpIcon.ed50f6b9.png";